import {
  ANSWER_VALUE_MAX_LENGTH,
  QUESTION_TYPE__LIST_OF_STRINGS,
} from '../../../constants';
import Question from '../Question';

export default class QuestionListOfStrings extends Question {
  constructor(doc) {
    super(doc);
    this.type = this.type || QUESTION_TYPE__LIST_OF_STRINGS;
  }

  getExpectedValueType(fieldName) {
    switch (fieldName) {
      case 'value': {
        if (this.settings && this.settings.pattern) {
          return {
            type: 'array',
            items: {
              type: 'string',
              pattern: this.settings.pattern,
            },
          };
        }
        return super.getExpectedValueType(fieldName);
      }
      default:
        return super.getExpectedValueType(fieldName);
    }
  }

  renderErrorMessage(error) {
    if (this.settings.patternErrorMessage) {
      return this.settings.patternErrorMessage;
    }
    return super.renderErrorMessage(error);
  }
}

QuestionListOfStrings.expectedRawKeys = ['value', 'other', 'text1', 'text2'];

QuestionListOfStrings.expectedValueType = {
  type: 'array',
  items: {
    type: 'string',
    maxLength: ANSWER_VALUE_MAX_LENGTH,
  },
};

QuestionListOfStrings.editorSettings = {
  limits: false,
  choices: false,
  snippets: false,
  additional: false,
};

Question.types[QUESTION_TYPE__LIST_OF_STRINGS] = QuestionListOfStrings;
